/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import hljs from "highlight.js";
/* Components */
import ShaiaBot from "../components/shaiaBot/shaiabot";
import Button from "../components/button/button";
/* Assets */
import ArrowBack from "../assets/icons/arrow_back.svg";
import { useMixPanel } from "../hooks/useMixPanel";
import useQuery from "../hooks/useQuery";
import { useTranslation } from 'react-i18next';
import useCaseABPStore from '../store/useCaseABPStore';
import useSessionStore from '../store/useSessionStore';
import MentuABPEditor from '../components/abp-editor/abpEditor';
import { MIX_PANEL_EVENTS } from '../utils/constans';
import Download from "../assets/icons/download.svg";
import Toolbar from "../components/toolbar/toolbar";
import { htmlToPdf } from '../utils/Utils';
import Icon from "../components/icon/icon";

const EditingABPBoard = () => {
const [isActive, setIsActive] = useState(false);
const navigate = useNavigate();
const { sendEvent } = useMixPanel();
const query = useQuery();
const type = query.get("type") || "coaching";
const { t } = useTranslation()
const { template } = useCaseABPStore();
const [windowSize, setWindowSize] = useState(getWindowSize());
const { user } = useSessionStore();
const userInfoString = localStorage.getItem("user");
const userInfo = JSON.parse(userInfoString || '{}'); 
const fullName = `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.email || `${userInfo.first_name || ''} ${userInfo.last_name || ''}`.trim(); 

  /* highlight */
  useEffect(() => {
    hljs.highlightAll();
  });

  useEffect(() => {
    if (!template) {
      navigate(-1);
    }
  }, [template, navigate]);

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const trackBackEvent = () => {
    sendEvent(MIX_PANEL_EVENTS.abpBackHome);
  }

  const exportAsPDF = async () => {
    htmlToPdf("Proyecto ABP", fullName);
    sendEvent(MIX_PANEL_EVENTS.abpDownloadPDF);
  };

  return (  
    <>
      <div className="back-button">
        <Link to={"/"} className="back-button_arrow" onClick={trackBackEvent}>
          <img src={ArrowBack} className="" alt="" /> {t('back')}
        </Link>
        <span className="back_button_root">{t('shaia')} /</span>
        <span className="back_button_page">{t('tablero_titulo')}</span>
      </div>
      <div className="wrapper editor">
        <div className="editor_board">
          <MentuABPEditor />
        </div>
        {windowSize.innerWidth > 576 && (
          <Toolbar>
            <Icon
              icon={Download}
              iconText={t("editor_barra_boton_descargar")}
              onClick={() => exportAsPDF()}
              customClassName="download"
              tooltipText={t("editor_barra_tooltip_descargar")}
            />
          </Toolbar>
        )}
        <div className="shaia-helper">
          <ShaiaBot />
          <Button
            label={t("editor_barra_boton_descargar")}
            variant="secondary"
            onClick={() => exportAsPDF()}
          />
        </div>
      </div>
    </>
  );
};

export default EditingABPBoard;

function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}